/// <reference path="./_references.ts"/>

module App.Administrative {

	export class AdministrativeService {
		constructor(
			private $http: ng.IHttpService,
			public Constants: IConstants
		) {

		}

		addImages(serviceRequestId: number, data: ServiceRequestPhoto): ng.IHttpPromise<ServiceRequestPhoto> {
			return this.$http.post(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/image`, data);
		}

		GetAppointmentChecklist(appointmentId: number): ng.IHttpPromise<AppointmentChecklist> {
			return this.$http.get(`${this.Constants.apiUrl}appointment/${appointmentId}/checklist`);
		}

		getGameConfig(): ng.IHttpPromise<GameConfig> {
			return <ng.IHttpPromise<GameConfig>>this.$http.get(`${this.Constants.apiUrl}organization/current/gameconfig`, {
				params: {
					'quiet': 1,
					'show_ranks': 1
				}
			});
		}

		getSRscore(serviceRequestId: number, params?: Object): ng.IHttpPromise<SRScore> {
			return <ng.IHttpPromise<SRScore>>this.$http.get(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/score`, { params: params || {} });
		}

		getTechScore(): ng.IHttpPromise<TechScore> {
			return <ng.IHttpPromise<TechScore>>this.$http.get(`${this.Constants.apiUrl}technician/current/score`);
		}

		UpdateAppointmentChecklist(appointmentId: number, checklist: AppointmentChecklist): ng.IHttpPromise<AppointmentChecklist> {
			return this.$http.put(`${this.Constants.apiUrl}appointment/${appointmentId}/checklist`, checklist);
		}

		GetServiceRequestChecklist(serviceRequestId: number): ng.IHttpPromise<ServiceRequestChecklist> {
			return this.$http.get(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/checklist`);
		}

		UpdateServiceRequestChecklist(serviceRequestId: number, checklist: ServiceRequestChecklist): ng.IHttpPromise<ServiceRequestChecklist> {
			return this.$http.put(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/checklist`, checklist);
		}

		CreateServiceRequestNote(serviceRequestId: number, note: string): ng.IHttpPromise<Note> {
			return this.$http.post(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/notes`, { description: note })
		}

		GetServiceRequestPhotos(serviceRequestId: number): ng.IHttpPromise<ServiceRequestPhoto[]> {
			return this.$http.get(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/image`);
		}

		UpdateServiceRequestPhotos(serviceRequestId: number, photo: ServiceRequestPhoto): ng.IHttpPromise<ServiceRequestPhoto[]> {
			return this.$http.put(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/image/${photo.id}`, photo);
		}

		DeleteServiceRequestPhoto(serviceRequestId: number, imageId: number): ng.IHttpPromise<ServiceRequestPhoto[]> {
			return this.$http.delete(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/image/${imageId}`);
		}

		public static Factory() {
			let instance = ($http: ng.IHttpService, Constants: IConstants) => {
				return new AdministrativeService($http, Constants);
			};

			instance.$inject = ['$http', 'Constants'];

			return instance;
		}
	}
}